var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "assess-left v-height-flag" },
    [
      _c("div", { staticClass: "head-portrait" }, [
        _vm.user !== "个人简历"
          ? _c("div", { staticClass: "avatar" }, [
              _vm.imageUrl
                ? _c("img", {
                    staticClass: "img",
                    attrs: { src: _vm.imageUrl },
                    on: { click: _vm.beforeUpload },
                  })
                : _c("img", {
                    staticClass: "img",
                    attrs: {
                      alt: "",
                      src: require("@/assets/images/portrait.png"),
                    },
                    on: { click: _vm.beforeUpload },
                  }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.user == "个人简历"
          ? _c(
              "div",
              { staticClass: "avatar" },
              [
                _c(
                  "el-upload",
                  {
                    staticClass: "upload-demo",
                    attrs: {
                      headers: _vm.myHeaders,
                      "http-request": _vm.uploadServerLog,
                      "show-file-list": false,
                      action: "##",
                    },
                  },
                  [
                    _vm.imageUrl
                      ? _c("img", {
                          staticClass: "img",
                          attrs: { src: _vm.imageUrl },
                        })
                      : _c("img", {
                          staticClass: "img",
                          attrs: {
                            alt: "",
                            src: require("@/assets/images/portrait.png"),
                          },
                        }),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "updata-text" }, [
          _c("span", { staticClass: "certificates" }, [
            _vm._v(_vm._s(_vm.userInfo ? _vm.userInfo.name : "证件照")),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "certificates-text" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.userInfo
                    ? _vm.userInfo.position
                    : "建议：734*1034 大小不超过2M"
                )
            ),
          ]),
          _vm._v(" "),
          _vm.userInfo
            ? _c("span", [
                _vm.userInfo.type == "在职"
                  ? _c("span", { staticClass: "unread bg1" }, [
                      _vm._v(_vm._s(_vm.userInfo.type)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.userInfo.type == "未入职"
                  ? _c(
                      "span",
                      { staticClass: "unread bg2", attrs: { type: "info" } },
                      [_vm._v(_vm._s(_vm.userInfo.type))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.userInfo.type == "离职"
                  ? _c(
                      "span",
                      {
                        staticClass: "unread bg3",
                        attrs: { effect: "plain", type: "info" },
                      },
                      [_vm._v(_vm._s(_vm.userInfo.type))]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "line" }),
      _vm._v(" "),
      _c("div", { staticClass: "catalogue" }, [_vm._v("简历目录")]),
      _vm._v(" "),
      _c("div", [
        _c(
          "ul",
          { staticClass: "assess-left-ul" },
          _vm._l(_vm.departmentData, function (item, index) {
            return _c(
              "li",
              {
                key: index,
                class: ["li-style", index === _vm.tabIndex && "li-active"],
                on: {
                  click: function ($event) {
                    return _vm.clickDepart(index, item.id)
                  },
                },
              },
              [
                _c(
                  "a",
                  { attrs: { navTo: "#" + index, rel: "external nofollow" } },
                  [
                    _vm._v(_vm._s(item.name) + " "),
                    _c("i", {
                      class: [_vm.user === "个人简历" ? item.icon : ""],
                    }),
                  ]
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            "before-close": _vm.handleClose,
            visible: _vm.dialogVisible,
            title: "选择图片",
            width: "850px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("upload-picture", {
            ref: "uploadPicture",
            attrs: { "check-button": true },
            on: { getImage: _vm.getImage },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }